import { Badge, Flex, Text } from "@radix-ui/themes";

export default function PricePeriodControl({
  period,
  setPeriod,
}: {
  period: "yearly" | "monthly";
  setPeriod: (period: "yearly" | "monthly") => void;
  isPromo?: boolean;
}) {
  return (
    <Flex className="bg-background-tertiary h-[48px] p-[4px] w-[308px] rounded-full border border-border-tertiary sticky top-[10px] z-[999] lg:relative lg:top-0">
      <>
        <Flex
          onClick={() => setPeriod("yearly")}
          data-testid="period-toggle-yearly"
          className={`flex-1 items-center justify-center rounded-full cursor-pointer gap-[4px] ${period === "yearly" ? "bg-white shadow-md" : null}`}
        >
          <Text className="font-bold text-[14px] text-blue-900">Yearly</Text>
          <Badge
            color="purple"
            className={`font-bold ${period === "monthly" ? "bg-purple-1" : ""}`}
          >
            Save 25%
          </Badge>
        </Flex>
        <Flex
          onClick={() => setPeriod("monthly")}
          data-testid="period-toggle-monthly"
          className={`flex-1 items-center justify-center cursor-pointer rounded-full ${period === "monthly" ? "bg-white shadow-md" : null}`}
        >
          <Text className="font-bold text-[14px] text-blue-900">Monthly</Text>
        </Flex>
      </>
    </Flex>
  );
}
